export class PasswordRequest {
  UserId: number;
  OldPassword: string;
  NewPassword: string;
  ConfirmPassword: string;
  QS: string;
  RequireQSValidation: boolean;
}
